var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"pi pi-spin pi-spinner",staticStyle:{"font-size":"2rem"}})])
}]

export { render, staticRenderFns }